export interface CoreInstanceSettingsMergePersonsAtImport
{
    mergePersonsAtImport: boolean
}
export interface CoreInstanceSettingsPurgeAfterDays {
    purgeAfterDays: number
}

export interface CorePasswordChangeInstanceSettings
{
   passwordChangeRoles :number
}

export enum CorePasswordChangeRole {
    STUDENT = 1,
    STAFF = 2
}

export interface CoreReservedValueImportError {
    rowNumber: number
    message: string
    missingHeaders?: string
}

export interface CoreReservedValuesImportPreview {
    uploadedCount: number
    existingCount: number
    addedCount: number
    removedCount: number
    updatedCount: number
    totalErrorCount: number
    errors: CoreReservedValueImportError[]
}
